import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, DatePicker, PaperClip } from 'components';
import { QuoteTypeService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { WhiteImage } from 'assets/img';

interface Props {
	title?: string;
	onClose?: any;
	item?: any;
}

class CreateQuoteType extends React.Component<Props> {

	state = {
		form: {
			name: '',
			recommendation: '',
			photo: ''
		}
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || '',
					recommendation: this.props.item?.recommendation || ''
				},
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.props.item != null) {
			await QuoteTypeService.admin.update({
				quote_type_id: this.props.item?.id,
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				photo: this.state.form.photo?.value || '',
			});
			Globals.showSuccess("Se ha modificado el tipo de cita correctamente");
			this.props.onClose();
		}
		else {
			if (!this.state.form.photo) {
				Globals.showError("Por favor, ingrese un icono para el tipo de cita");
				return;
			}

			await QuoteTypeService.admin.create({
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				photo: this.state.form.photo?.value || '',
			});
			Globals.showSuccess("Se ha creado el tipo de cita correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="create-quote-type">
				<TitleModalRight
					title={ this.props.title }
					onClose={ this.props.onClose }
				/>
				<form className="container-scroll-modal-right" onSubmit={ this.submit }>
					<div className="col-md-12 text-center">
						<PaperClip
							className="paperclip-image"
							value={ this.state.form.photo }
							onChange={ (e: any) => {
								this.setState({
									form: {
										...this.state.form,
										photo: e.target
									}
								})
							} }>
							{/*
							// @ts-ignore */}
							<img className={ `selected-image ${ (this.state.form.photo || this.props.item?.photo) ? '' : 'inactive' }` } src={ this.state.form.photo?.dataURL || (this.props.item?.photo ? (Constants.BASE_STORAGE + this.props.item?.photo) : WhiteImage) } />
						</PaperClip>
						<p className="paperclip-title">Icono</p>
					</div>
					<div className="col-md-12">
						<Input
							color="white"
							value={ this.state.form.name }
							name="name"
							placeholder="Nombre"
							onChange={ this.change } />
					</div>
					<div className="col-md-12">
						<Input
							color="white"
							value={ this.state.form.recommendation }
							name="recommendation"
							placeholder="Recomendación (Opcional)"
							onChange={ this.change } />
					</div>
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateQuoteType;